type ClientFetchInit = RequestInit & {
  /** When true, bypass HTTP cache (mutations, auth-sensitive reads). */
  noStore?: boolean;
};

/**
 * App-wide JSON fetch — React Query owns client caching; avoid `no-store` on reads
 * unless the response must never be cached by the browser.
 */
export async function clientFetch(
  input: RequestInfo | URL,
  init?: ClientFetchInit,
): Promise<Response> {
  const { noStore, ...rest } = init ?? {};
  return fetch(input, {
    credentials: "include",
    ...rest,
    cache: noStore ? "no-store" : rest.cache ?? "default",
  });
}

export async function clientFetchJson<T>(
  input: RequestInfo | URL,
  init?: ClientFetchInit,
): Promise<T> {
  const res = await clientFetch(input, init);
  if (!res.ok) {
    throw new Error(`Request failed: ${res.status}`);
  }
  const payload = (await res.json()) as { success?: boolean; data?: T };
  if (payload && typeof payload === "object" && "data" in payload) {
    return payload.data as T;
  }
  return payload as T;
}
